import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export function createAgendaApi({ checkInInstanceId, questionId, text, status, uiKey }) {
  const url = endpoints.agenda.create;
  return sendRequest({
    url,
    method: 'POST',
    queryParams: { questionId },
    credentials: 'include',
    body: {
      checkInInstanceId,
      text,
      status,
      uiKey,
    },
  });
}

export function updateAgendaApi({ agendaId, questionId, checkInInstanceId, text, status }) {
  const url = endpoints.agenda.update(agendaId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      questionId,
    },
    body: {
      text,
      status,
      checkInInstanceId,
    },
  });
}

export function getAgendasApi({ checkInId, offset, limit }) {
  const url = endpoints.agenda.checkIn(checkInId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      offset,
      limit,
    },
  });
}

export function deleteAgendaApi({ agendaId }) {
  const url = endpoints.agenda.delete(agendaId);
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
}

export function addToAgendaApi({ checkInInstanceId, questionId, label, levelUpInfo, uiKey }) {
  const url = endpoints.agenda.addToAgenda;
  return sendRequest({
    url,
    method: 'POST',
    queryParams: { questionId },
    credentials: 'include',
    body: {
      checkInInstanceId,
      label,
      uiKey,
      levelUpInfo,
    },
  });
}
